import { render, staticRenderFns } from "./BoxPerformanceComparisonLinePeerGroup.vue?vue&type=template&id=66e3dc45&scoped=true&"
import script from "./BoxPerformanceComparisonLinePeerGroup.vue?vue&type=script&lang=js&"
export * from "./BoxPerformanceComparisonLinePeerGroup.vue?vue&type=script&lang=js&"
import style0 from "./BoxPerformanceComparisonLinePeerGroup.vue?vue&type=style&index=0&id=66e3dc45&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3dc45",
  null
  
)

export default component.exports
import {QCard,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QBtnToggle})
